import { defineStore } from 'pinia';
export const userStore = defineStore('user', () => {
    const token = ref('');
    const userName = ref('');
    const remember = ref(false);
    const clearUserStore = () => {
        token.value = '';
        userName.value = '';
        remember.value = false;
    };
    // 正确：返回状态和方法，暴露给 Store 实例
    return { token, userName, remember, clearUserStore };
}, {
    persist: {
        enabled: true,
        storage: sessionStorage
    }
});
//# sourceMappingURL=user.js.map